import React from 'react';

export const Menu = ({ color = '#F8F8FD' }: { color: string }) => (
  <svg width="100%" height="100%" viewBox="0 0 56 57" fill="none">
    <line x1="12" y1="17.8345" x2="44" y2="17.8345" stroke={color} strokeWidth="2" />
    <line x1="12" y1="29.8345" x2="44" y2="29.8345" stroke={color} strokeWidth="2" />
    <line x1="12" y1="41.8345" x2="44" y2="41.8345" stroke={color} strokeWidth="2" />
  </svg>
);
